<script lang="ts">
  import type { Diligence } from "../../../../Model/Diligence";
  import type { PoliceManifestationTraffic } from "../../../../Model/PoliceManifestationTraffic";
  import { usersService } from "../../../../services";
  import { Input, Label, TabContent, TabPane } from "sveltestrap";
  import ParamSelect from "../../../ParamSelect.svelte";
  import { getContext, select_value } from "svelte/internal";
  import type { User } from "../../../../Model/User"
  import { dateInputFormatter, dateTimeInputFormatter } from "../../../../services/Functions";
  import PoliceManifestationFinishForm from "../../Global/PoliceManifestationFinishForm.svelte";
  import CroquisData from "./CroquisData.svelte";
  import type { Writable } from "svelte/store";

  export let diligence: Diligence;

  const policeManifestationTraffic: Writable<PoliceManifestationTraffic> = getContext('policeManifestationTraffic');
  

  let users: User[];
  
  let offset: number = 0;
  let limit: number = 179;
  let searchFilter = null;


  let arrivalTime: string;
  let hourCommunicate: string;
  let referralDate: string;
  let dateCheckEthilometer: string;

  $: loadPoliceManifestationTraffic(diligence);

  $: loadUsers();
  async function loadUsers() {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter,
      },
    };
    try {
      users = await usersService.findUsers(opts);
    } catch (err) {}
  }

  async function loadPoliceManifestationTraffic(diligence) {
    if ($policeManifestationTraffic) {
      arrivalTime = dateTimeInputFormatter($policeManifestationTraffic.arrivalTime);
      hourCommunicate = dateTimeInputFormatter($policeManifestationTraffic.hourCommunicate);
      referralDate = dateInputFormatter($policeManifestationTraffic.referralDate);
      dateCheckEthilometer =  dateInputFormatter($policeManifestationTraffic.dateCheckEthilometer);
    }
  }

  // async function save() {
  //   try {
  //     await policeManifestationTrafficService.savePoliceManifestationTraffic(policeManifestationTraffic)
  //     success("Datos guardados con exito");
  //   } catch (err) {
  //     error("Comprueba los campos");
  //   }
  // }

  function onHandleChange() {
    policeManifestationTraffic.update(manifest => {
      manifest.arrivalTime = new Date("2019-01-01T" + arrivalTime + ":00.000Z");
      manifest.hourCommunicate = new Date("2019-01-01T"+ hourCommunicate + ":00.000Z");
      manifest.referralDate = new Date(referralDate + "T00:00:00.000Z");
      manifest.dateCheckEthilometer = dateCheckEthilometer + "T00:00:00.000Z";
      return manifest;
    })
  }


  function getUser(): string {
    let user: User = JSON.parse(localStorage.getItem("current_user"));
    return user.id;
  }

</script>

{#if diligence }
<div class="mt-3">
  <TabContent>
    <TabPane tabId="ManiPol" tab="Datos" active>
      <PoliceManifestationFinishForm {diligence} />
    </TabPane>
    {#if $policeManifestationTraffic}
      <TabPane tabId="ManiPolData" tab="Atestado">
        <div class="row mt-3">
          <div class="col-12 mb-3">
            <Label for="matricula">Explicación Ubicación</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationTraffic.crowdedLocation}
            />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="marca">Tipo de Atestado</Label>
            <ParamSelect bind:paramSelectId={$policeManifestationTraffic.crowdedType} paramType="diligencesTypes" nothing={true} />
          </div>
          <div class="col-12 col-sm-2 mb-3">
            <Label for="tipoVeh">Hora Comunica</Label>
            <Input type="time" id="matricula"          
              on:change={onHandleChange}
              bind:value={hourCommunicate}  />
          </div>
          <div class="col-12 col-sm-2 mb-3">
            <Label for="fechaMatri">Hora Llegada</Label>
            <Input type="time" id="matricula"
              on:change={onHandleChange}
              bind:value={arrivalTime} />
          </div>
          <div class="col-12 mb-3">
            <Label for="modelo">Informe</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationTraffic.report}
            />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="fechaMatri">Comunicante</Label>
            <div class="input-group">
              <ParamSelect bind:paramSelectId={$policeManifestationTraffic.communicantThird} paramType='callerType' nothing/>
              <!-- {#if users}
                <select class="form-select" bind:value={$policeManifestationTraffic.communicantThird}>
                  {#each users as usr}
                    <option value={usr.id}> {usr.name} </option>
                  {/each}
                </select>
              {/if} -->
            </div>
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="companiaSeguro">Señalizacion</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationTraffic.signaling} />
          </div>
          <div class="col-12 col-sm-2 mb-3">
            <Label for="visibilidad">Accidente de tráfico</Label>
            <Input type="select" id="trafficAccident" on:change={(e) => {$policeManifestationTraffic.trafficAccident = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.trafficAccident.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <Label for="validezSeguro">Observaciones </Label>
            <textarea class="form-control" id="exampleFormControlTextarea1" bind:value={$policeManifestationTraffic.observations}  rows="3"></textarea>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <Label for="validezSeguro">Características de la via </Label>
            <textarea class="form-control" id="exampleFormControlTextarea1" bind:value={$policeManifestationTraffic.featuresVia}  rows="3"></textarea>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="polizaSeguro">Huellas</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationTraffic.footprints} />
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="validezInspeccion">Características día</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationTraffic.characteristicsDay} />
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="correspondiente">Control preventivo</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.preventiveControl = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.preventiveControl.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="correspondiente">Perdida de puntos</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.lostPoints = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.lostPoints.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="correspondiente">Decisión judicial</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.judicialDecision = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.judicialDecision.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="correspondiente">No poseer permiso</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.notPossessPermission = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.notPossessPermission.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <Label for="matriculaRemolque">Vehículo Inmovilizado</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.vehicleImmobilization = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.vehicleImmobilization.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-3 m mb-3">
            <Label for="danios">Persona Habilitada</Label>
            <Input type="select" id="correspondiente" on:change={(e) => {$policeManifestationTraffic.qualifiedPerson = (select_value(e.target) === "true")}} value={$policeManifestationTraffic.qualifiedPerson.toString()}>
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-12 mb-3">
            <Label for="validezInspeccion">Anomalias Conducción</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationTraffic.drivingAnomalies}
            />
          </div>
        </div>
      </TabPane>
      <TabPane tabId="EtilPol" tab="Etilometro">
        <div class="row mt-3 mb-3">
          <div class="col-12 col-sm-6">
            <Label for="validezInspeccion">Etilometro Serie</Label>
            <ParamSelect bind:paramSelectId={$policeManifestationTraffic.ethylmeterSeries} paramType="etilometroSeries" nothing={true} />
          </div>
          <div class="col-12 col-sm-6">
            <Label for="validezInspeccion">Fecha Verificación Etilometro</Label>
            <Input type="date" id="matricula" 
            on:change={onHandleChange}
            bind:value={dateCheckEthilometer} />
          </div>
        </div>
      </TabPane>
      <TabPane tabId="AboPol" tab="Remisión">
        <div class="row mt-3 mb-3">
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Núm. de actas remisión</Label>
            <Input type="number" id="matricula" bind:value={$policeManifestationTraffic.numMinutesRemision} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Núm. de folios remisión</Label>
            <Input type="number" id="matricula" bind:value={$policeManifestationTraffic.numFoliosRemision} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Fecha remisión</Label>
            <Input type="date" id="matricula" 
            on:change={onHandleChange}
            bind:value={referralDate} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Acta independizada</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationTraffic.independentMinutes} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Núm. citaciones</Label>
            <Input type="number" id="matricula" bind:value={$policeManifestationTraffic.numcitations} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Citaciones</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationTraffic.citations} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Cuerpo traspaso</Label>
            <ParamSelect
              bind:paramSelectId={$policeManifestationTraffic.bodyTransfer}
              paramType="courts"
              nothing={true}
            />
          </div>
        </div>
      </TabPane>
      <TabPane tabId="CroquisData" tab="Croquis">
        <div class="row mt-2 mb-2 ">
          <div class="col-12">
            <CroquisData />
          </div>
          <div class="col-12 mb-3">
            <Label for="mark">Explicación Croquis</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationTraffic.sketchExplanation}
            />
          </div>
        </div>
      </TabPane>
    {/if}

  </TabContent>



  

</div>

{/if}
